import { render, staticRenderFns } from "./FaultDuty.vue?vue&type=template&id=73ab5beb&scoped=true"
import script from "./FaultDuty.vue?vue&type=script&lang=js"
export * from "./FaultDuty.vue?vue&type=script&lang=js"
import style0 from "./FaultDuty.vue?vue&type=style&index=0&id=73ab5beb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab5beb",
  null
  
)

export default component.exports